import { render, staticRenderFns } from "./orderProduct.vue?vue&type=template&id=65437c6c&scoped=true&"
import script from "./orderProduct.vue?vue&type=script&lang=js&"
export * from "./orderProduct.vue?vue&type=script&lang=js&"
import style0 from "./orderProduct.vue?vue&type=style&index=0&id=65437c6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65437c6c",
  null
  
)

export default component.exports